import apiClient from "./apiClient";

export type ValidateInvitationResponse = {
  email: string;
  firstName: string | null;
};

export type AcceptInvitationBody = {
  token: string;
  password: string;
  companyName: string;
  employeesCount?: string;
  role?: string;
};

export const validateInvitation = async (token: string) => {
  const response = await apiClient.get<ValidateInvitationResponse>(
    "/auth/invitations/validate",
    { params: { token } },
  );
  return response.data;
};

export const acceptInvitation = async (body: AcceptInvitationBody) => {
  const response = await apiClient.post("/auth/invitations/accept", body);
  return response.data;
};

export const requestPasswordResetEmail = async (email: string) => {
  const response = await apiClient.post("/auth/forgot-password", { email });
  return response.data;
};

export type SubmitPasswordResetBody = {
  token: string;
  newPassword: string;
};

export const submitPasswordReset = async (body: SubmitPasswordResetBody) => {
  const response = await apiClient.post("/auth/reset-password", body);
  return response.data;
};

export const logoutSession = async () => {
  await apiClient.post("/auth/logout");
};

